export const SET_LABORATORY_IMAGES_GROUPS = 'SET_LABORATORY_IMAGES_GROUPS';
export const SET_LABORATORY_TEST_GROUPS = 'SET_LABORATORY_TEST_GROUPS';
export const SET_LABORATORY_FACTOR_LIST = 'SET_LABORATORY_FACTOR_LIST';
export const SET_FETCHING_STATE = 'SET_FETCHING_STATE';
export const DELETE_LABORATORY_TEST = 'DELETE_LABORATORY_TEST';
